import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminDocuments: build.query<
      GetV2AdminDocumentsApiResponse,
      GetV2AdminDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.organizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2AdminDocumentsByDocumentId: build.query<
      GetV2AdminDocumentsByDocumentIdApiResponse,
      GetV2AdminDocumentsByDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/documents/${queryArg.documentId}`,
      }),
    }),
    getV2AdminOrganizationsByOrganizationIdDocuments: build.query<
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse,
      GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/organizations/${queryArg.pathOrganizationId}/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.queryOrganizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderDocuments: build.query<
      GetV2ProviderDocumentsApiResponse,
      GetV2ProviderDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/documents`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          document_type: queryArg.documentType,
          organization_id: queryArg.organizationId,
          patient_id: queryArg.patientId,
          include_deleted: queryArg.includeDeleted,
          start_date: queryArg.startDate,
          end_date: queryArg.endDate,
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    postV2ProviderDocumentsExtract: build.mutation<
      PostV2ProviderDocumentsExtractApiResponse,
      PostV2ProviderDocumentsExtractApiArg
    >({
      query: () => ({ url: `/v2/provider/documents/extract`, method: "POST" }),
    }),
    getV2ProviderDocumentsExtractTasks: build.query<
      GetV2ProviderDocumentsExtractTasksApiResponse,
      GetV2ProviderDocumentsExtractTasksApiArg
    >({
      query: () => ({ url: `/v2/provider/documents/extract/tasks` }),
    }),
    getV2ProviderDocumentsExtractByTaskIdStatus: build.query<
      GetV2ProviderDocumentsExtractByTaskIdStatusApiResponse,
      GetV2ProviderDocumentsExtractByTaskIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/documents/extract/${queryArg.taskId}/status`,
      }),
    }),
    postV2ProviderDocumentsGenerateAndSend: build.mutation<
      PostV2ProviderDocumentsGenerateAndSendApiResponse,
      PostV2ProviderDocumentsGenerateAndSendApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/documents/generate-and-send`,
        method: "POST",
        body: queryArg.generateAndSendRequest,
      }),
    }),
    getV2ProviderDocumentsProxyByDocumentId: build.query<
      GetV2ProviderDocumentsProxyByDocumentIdApiResponse,
      GetV2ProviderDocumentsProxyByDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/documents/proxy/${queryArg.documentId}`,
        params: {
          disposition: queryArg.disposition,
        },
      }),
    }),
    getV2ProviderDocumentsByDocumentId: build.query<
      GetV2ProviderDocumentsByDocumentIdApiResponse,
      GetV2ProviderDocumentsByDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/documents/${queryArg.documentId}`,
      }),
    }),
    postV2ProviderEncountersByEncounterIdDocuments: build.mutation<
      PostV2ProviderEncountersByEncounterIdDocumentsApiResponse,
      PostV2ProviderEncountersByEncounterIdDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/documents`,
        method: "POST",
        body: queryArg.createDocumentRequest,
      }),
    }),
    deleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentId:
      build.mutation<
        DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
        DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
          method: "DELETE",
        }),
      }),
    getV2ProviderEncountersByEncounterIdDocumentsAndDocumentId: build.query<
      GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
      GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
      }),
    }),
    patchV2ProviderEncountersByEncounterIdDocumentsAndDocumentId:
      build.mutation<
        PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse,
        PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/encounters/${queryArg.encounterId}/documents/${queryArg.documentId}`,
          method: "PATCH",
          body: queryArg.documentUpdate,
        }),
      }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminDocumentsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type GetV2AdminDocumentsByDocumentIdApiResponse =
  /** status 200 OK */ DocumentDetailResponse;
export type GetV2AdminDocumentsByDocumentIdApiArg = {
  documentId: string;
};
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2AdminOrganizationsByOrganizationIdDocumentsApiArg = {
  pathOrganizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  queryOrganizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type GetV2ProviderDocumentsApiResponse =
  /** status 200 OK */ DocumentListResponse;
export type GetV2ProviderDocumentsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page */
  perPage?: number;
  /** Filter by document type (e.g., 'lab_order', 'claim', 'form') */
  documentType?: string | null;
  /** Filter by organization ID */
  organizationId?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
  /** Whether to include soft-deleted documents */
  includeDeleted?: boolean;
  /** Start date for filtering (ISO 8601 format) */
  startDate?: string | null;
  /** End date for filtering (ISO 8601 format) */
  endDate?: string | null;
  /** Text search on filename and document title */
  search?: string | null;
  /** Field to sort by (created_at, updated_at, filename, size_bytes) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
};
export type PostV2ProviderDocumentsExtractApiResponse =
  /** status 200 OK */ ExtractionUploadResponse;
export type PostV2ProviderDocumentsExtractApiArg = void;
export type GetV2ProviderDocumentsExtractTasksApiResponse =
  /** status 200 OK */ ListExtractionTasksResponse;
export type GetV2ProviderDocumentsExtractTasksApiArg = void;
export type GetV2ProviderDocumentsExtractByTaskIdStatusApiResponse =
  /** status 200 OK */ ExtractionStatusResponse;
export type GetV2ProviderDocumentsExtractByTaskIdStatusApiArg = {
  taskId: string;
};
export type PostV2ProviderDocumentsGenerateAndSendApiResponse =
  /** status 200 OK */ GenerateAndSendResponse;
export type PostV2ProviderDocumentsGenerateAndSendApiArg = {
  generateAndSendRequest: GenerateAndSendRequest;
};
export type GetV2ProviderDocumentsProxyByDocumentIdApiResponse = unknown;
export type GetV2ProviderDocumentsProxyByDocumentIdApiArg = {
  documentId: string;
  /** Content-Disposition: 'inline' for viewing in browser, 'attachment' for download */
  disposition?: "inline" | "attachment";
};
export type GetV2ProviderDocumentsByDocumentIdApiResponse =
  /** status 200 OK */ DocumentDetailResponse;
export type GetV2ProviderDocumentsByDocumentIdApiArg = {
  documentId: string;
};
export type PostV2ProviderEncountersByEncounterIdDocumentsApiResponse =
  /** status 201 Created */ DocumentResponse;
export type PostV2ProviderEncountersByEncounterIdDocumentsApiArg = {
  encounterId: string;
  createDocumentRequest: CreateDocumentRequest;
};
export type DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  unknown;
export type DeleteV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg =
  {
    encounterId: string;
    documentId: string;
  };
export type GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ DocumentResponse;
export type GetV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg = {
  encounterId: string;
  documentId: string;
};
export type PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiResponse =
  /** status 200 OK */ DocumentResponse;
export type PatchV2ProviderEncountersByEncounterIdDocumentsAndDocumentIdApiArg =
  {
    encounterId: string;
    documentId: string;
    documentUpdate: DocumentUpdate;
  };
export type CommunicationChannelStatus = {
  /** Communication channel: 'sms' or 'email' */
  channel: string;
  /** When message was delivered */
  delivered_at?: string | null;
  /** Error details if delivery failed */
  error_message?: string | null;
  /** When delivery failed */
  failed_at?: string | null;
  /** When message was sent */
  sent_at?: string | null;
  /** Delivery status: queued, sent, delivered, failed, bounced, dropped, opened, clicked */
  status: string;
};
export type FormStatusInfo = {
  /** ID of the form session */
  form_session_id: string;
  /** Form status: pending, in_progress, or completed */
  status: string;
  /** When the form was submitted */
  submitted_at?: string | null;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type DocumentSummaryResponse = {
  /** Per-channel delivery status if document was sent to patient */
  communication_status?: CommunicationChannelStatus[] | null;
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  /** Unique identifier for the document */
  document_id: string;
  /** User-friendly title for the document */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'claim', 'form') */
  document_type?: string | null;
  /** Original filename */
  filename: string;
  /** Form lifecycle status if document originated from a form submission */
  form_status?: FormStatusInfo | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  /** File size in bytes */
  size_bytes: number;
};
export type DocumentListResponse = {
  items: DocumentSummaryResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type InsuranceSummary2 = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo2 = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary2[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type DocumentDetailResponse = {
  /** MIME type (e.g., 'application/pdf') */
  content_type: string;
  /** When document was created (ISO 8601 UTC) */
  created_at: string;
  /** When document was deleted (ISO 8601 UTC) */
  deleted_at?: string | null;
  /** Unique identifier for the document */
  document_id: string;
  /** User-friendly title for the document */
  document_title?: string | null;
  /** Type of document (e.g., 'lab_order', 'claim', 'form') */
  document_type?: string | null;
  /** Presigned S3 URL for downloading the document */
  download_url?: string | null;
  /** Unix timestamp when download URL expires */
  download_url_expires_at?: number | null;
  /** Original filename */
  filename: string;
  /** MD5 checksum for integrity */
  md5_hash: string;
  /** Organization the document belongs to */
  organization_id?: string | null;
  /** Patient information if patient_id is set */
  patient?: PatientInfo2 | null;
  /** Patient associated with the document */
  patient_id?: string | null;
  /** Provider who owns the document */
  provider_id: string;
  /** File size in bytes */
  size_bytes: number;
  /** When document was last updated (ISO 8601 UTC) */
  updated_at?: string | null;
};
export type ExtractionRuleResponse = {
  approved_rule_id?: string | null;
  body_md: string;
  facets: {
    [key: string]: string[];
  };
  selector_text: string;
  status?: string;
  title: string;
};
export type ExtractionFileResponse = {
  document_id: string;
  draft_rule_ids?: string[] | null;
  extracted_rules?: ExtractionRuleResponse[] | null;
  filename: string;
  is_duplicate: boolean;
  llm_doc_type?: string | null;
  llm_summary?: string | null;
  llm_title?: string | null;
  progress?: string | null;
  rules_extracted?: number | null;
  status?: string | null;
  thread_id?: string | null;
};
export type ExtractionUploadResponse = {
  /** List of files being processed */
  files: ExtractionFileResponse[];
  /** Thread ID of the parent orchestrator workflow */
  orchestrator_thread_id: string;
  /** Initial status of the task */
  status: string;
  /** Unique identifier for the extraction task */
  task_id: string;
};
export type ExtractionTaskSummary = {
  /** Rules that were approved */
  approved_rules_count?: number;
  /** Thread ID for extraction chat, if started */
  chat_thread_id?: string | null;
  /** When the task completed */
  completed_at?: string | null;
  /** Number of completed files */
  completed_count?: number;
  /** When the task was created */
  created_at: string;
  /** Summary of documents: filename, llm_title, llm_doc_type */
  documents?: {
    [key: string]: any;
  }[];
  /** Rules still in draft state */
  draft_rules_count?: number;
  /** Number of failed files */
  failed_count?: number;
  /** Number of files in the task */
  file_count: number;
  /** Rules that were rejected */
  rejected_rules_count?: number;
  /** Current status of the task */
  status: string;
  /** Unique identifier for the extraction task */
  task_id: string;
  /** Total number of rules extracted */
  total_rules_extracted?: number;
  /** When the task was last updated */
  updated_at: string;
};
export type ListExtractionTasksResponse = {
  /** List of extraction task summaries */
  tasks: ExtractionTaskSummary[];
  /** Total number of tasks for this organization */
  total: number;
};
export type ExtractionRuleResponse2 = {
  approved_rule_id?: string | null;
  body_md: string;
  facets: {
    [key: string]: string[];
  };
  selector_text: string;
  status?: string;
  title: string;
};
export type ExtractionFileResponse2 = {
  document_id: string;
  draft_rule_ids?: string[] | null;
  extracted_rules?: ExtractionRuleResponse2[] | null;
  filename: string;
  is_duplicate: boolean;
  llm_doc_type?: string | null;
  llm_summary?: string | null;
  llm_title?: string | null;
  progress?: string | null;
  rules_extracted?: number | null;
  status?: string | null;
  thread_id?: string | null;
};
export type ExtractionStatusResponse = {
  completed_at?: string | null;
  completed_count: number;
  created_at?: string | null;
  failed_count: number;
  file_count: number;
  files: ExtractionFileResponse2[];
  status: string;
  summary_results?: {
    [key: string]: any;
  } | null;
  task_id: string;
};
export type GenerateAndSendResponse = {
  /** Channels the document was sent through */
  channels: string[];
  /** ID of the generated document */
  document_id: string;
  /** Success or error message */
  message: string;
  /** Patient the document was sent to */
  patient_id: string;
  /** Whether the operation was successful */
  success: boolean;
};
export type GenerateAndSendRequest = {
  /** Communication channels (e.g., ['sms'], ['email'], or both) */
  channels: string[];
  /** Optional title for the document */
  document_title?: string | null;
  /** Markdown content to convert to PDF */
  markdown: string;
  /** Optional custom message to include with the document */
  message?: string | null;
  /** Patient to send the document to */
  patient_id: string;
};
export type DocumentResponse = {
  /** Document content */
  content?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Document description */
  description?: string | null;
  /** Document ID */
  encounter_document_id: string;
  /** Last modification timestamp */
  modified_at: string;
  /** Document title */
  title?: string | null;
  /** Transcription session ID for recording documents */
  transcription_session_id?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type CreateDocumentRequest = {
  /** Document content */
  content?: string | null;
  /** Document description */
  description?: string | null;
  /** Document title */
  title?: string | null;
  /** Transcription session ID for recording documents */
  transcription_session_id?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type DocumentUpdate = {
  /** Document content */
  content?: string | null;
  /** Document description */
  description?: string | null;
  /** Document title */
  title?: string | null;
};
